import { render, staticRenderFns } from "./Megadoc.vue?vue&type=template&id=2c0fc38e&scoped=true"
import script from "./Megadoc.vue?vue&type=script&lang=js"
export * from "./Megadoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0fc38e",
  null
  
)

export default component.exports